var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-section',[_c('p',{staticClass:"font-weight-bold font-size-20 mb-0 mt-3"},[_vm._v("Errore di caricamento")]),_c('p',[_vm._v("Prova a ricaricare la pagina")]),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.notifyReload}},[_vm._v("Ricarica")])])
}
var staticRenderFns = []

export { render, staticRenderFns }